import { ClientConfig, createClientConfig } from "@/libs/clientConfig";
import { createContext, useContext } from "react";

export const ConfigContext = createContext<ClientConfig>(createClientConfig());

export const useClientConfig = () => useContext(ConfigContext);
